"use client";
import Link from "next/link";
import { FadeUp } from "@/components/ui/section";
import Button from "@/components/ui/button";
import { useTranslations } from "next-intl";

export default function DedicatedExperts() {
  const t = useTranslations("home");
  const STATS = t.raw("dedicatedExpertsStats");
  const approach = t.raw("dedicatedExpertsApproach");

  return (
    <section className="py-24 lg:py-32 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          <FadeUp>
            <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6">
              {t("dedicatedExpertsTitle")}
            </h2>
            <div className="grid grid-cols-3 gap-4 mb-10">
              {STATS.map(({ value, label }) => (
                <div key={label}>
                  <div className="text-3xl font-mono font-bold bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">
                    {value}
                  </div>
                  <div className="text-xs text-zinc-500 mt-1">{label}</div>
                </div>
              ))}
            </div>
            <Link href="/contact">
              <Button variant="primary">{t("startAProject")}</Button>
            </Link>
          </FadeUp>

          <FadeUp delay={0.2}>
            <div className="relative rounded-2xl bg-white/[0.03] border border-white/10 p-8 backdrop-blur-xl">
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-violet-500/10 to-transparent pointer-events-none" />
              <div className="relative space-y-4">
                <p className="text-sm font-mono text-zinc-500">{"// our approach"}</p>
                <div className="space-y-3">
                  {approach.map((item) => (
                    <div key={item} className="flex items-center gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-violet-500 to-cyan-500 flex-shrink-0" />
                      <span className="text-sm text-zinc-300">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </FadeUp>

        </div>
      </div>
    </section>
  );
}
